<div class="reset-password-holder">
    <serviceos-ng-local-loader [showLoader]="showLocalLoader"></serviceos-ng-local-loader>
    <div class="title-holder">
        <h2 *ngIf="moduleAuthTexts$ | async as moduleAuthTexts">{{ moduleAuthTexts.forgot_label ? moduleAuthTexts.forgot_label : 'Forgot your password?' }}</h2>
        <serviceos-ng-alert class="error-alert" *ngIf="formErrorMessage" [type]="'error'">
            {{ formErrorMessage }}
        </serviceos-ng-alert>
    </div>
    <form
        [formGroup]="resetPasswordForm"
        (ngSubmit)="processForm()"
        #templateResetPForm="ngForm"
        *ngIf="!emailSent; else confirmationMessageBox"
    >
        <div class="obf-form-part">
            <div class="mb-3">
                <p *ngIf="moduleAuthTexts$ | async as moduleAuthTexts">{{moduleAuthTexts.send_link_message ? moduleAuthTexts.send_link_message : 'Enter your email here and we will send you a link to reset your password.'}}</p>
            </div>
            <div class="input-holder">
                <serviceos-ng-form-field>
                    <serviceos-ng-label *ngIf="moduleAuthTexts$ | async as moduleAuthTexts">{{ moduleAuthTexts.sign_up_label ? moduleAuthTexts.sign_up_label : componentSettings?.fields?.email?.label }}</serviceos-ng-label>
                    <input
                        [serviceosNgInput]="email?.value"
                        [error]="
                        email?.invalid && templateResetPForm.submitted
                        "
                        type="text"
                        id="email"
                        name="email"
                        formControlName="email"
                    />
                    <serviceos-ng-error-message *ngIf="email?.errors?.email && email?.value?.length">
                        <ng-container *ngIf="moduleAuthTexts$ | async as moduleAuthTexts">
                            {{ moduleAuthTexts.email_field_error ? moduleAuthTexts.email_field_error : componentSettings?.fields?.email?.errMsgs?.format }}
                        </ng-container>
                    </serviceos-ng-error-message>
                    <serviceos-ng-error-message *ngIf="!(email?.errors?.email && email?.value?.length)">
                        <ng-container *ngIf="moduleAuthTexts$ | async as moduleAuthTexts">
                            {{ moduleAuthTexts.email_field_error ? moduleAuthTexts.email_field_error : componentSettings?.fields?.email?.errMsgs?.required }}
                        </ng-container>
                    </serviceos-ng-error-message>
                </serviceos-ng-form-field>
            </div>

            <div>
                <serviceos-ng-button
                    [isSubmitButton]="true"
                    [type]="'primary'"
                    [isFullWidth]="true"
                    *ngIf="moduleAuthTexts$ | async as moduleAuthTexts"
                    >
                    {{ moduleAuthTexts.submit_button_label ? moduleAuthTexts.submit_button_label : componentSettings?.fields?.submitButton?.label }}
                </serviceos-ng-button>
            </div>
        </div>
    </form>

    <ng-template #confirmationMessageBox>
        <p *ngIf="moduleAuthTexts$ | async as moduleAuthTexts">
            {{ moduleAuthTexts.confirmation_message ? moduleAuthTexts.confirmation_message : 'A link to reset your password has been sent to' }} <b>{{ confirmationEmail }}</b>
        </p>
    </ng-template>

    <div class="back-to-login">
        <span
            class="link-color cursor"
            (click)="changeScreenHandler('login')"
            *ngIf="moduleAuthTexts$ | async as moduleAuthTexts"
            >
            {{ moduleAuthTexts.back_button_label ? moduleAuthTexts.back_button_label : 'Go back' }}
        </span>
    </div>
</div>
